// Yeni Paket Müşterisi penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.addPackageCustomer';

export const addPackageCustomerGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Yeni paket müşterisi nasıl kaydedilir?'),
  intro: t(`${G}.intro`, 'Telefonla sipariş veren yeni bir müşteriyi teslimat adresiyle birlikte kaydedersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Müşteri ve adres'),
    footer: t(`${G}.regions.footer`, 'Müşteriyi Kaydet'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. "Paket Müşterisi" grubunu kontrol edin'),
      text: t(`${G}.s1.text`, 'Yeni müşteri "Paket Müşterisi" cari grubunda açılır. Pencerenin üstünde yeşil "Paket Müşterisi grubu mevcut" yazıyorsa devam edin.'),
      tips: [
        t(`${G}.s1.tip1`, 'Sarı uyarıda "Paket Müşterisi cari grubu bulunamadı" yazıyorsa "Grubu Oluştur"a basın. Grup yokken "Müşteriyi Kaydet" düğmesi kapalıdır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Ad ve telefonu yazın'),
      text: t(`${G}.s2.text`, '"Müşteri Adı" ve "Telefon" zorunludur; telefonu 05XX XXX XXXX biçiminde yazın. E-posta ve Müşteri Notu (ör. "kapıda nakit tercih ediyor") isteğe bağlıdır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Teslimat adresini girin'),
      text: t(`${G}.s3.text`, '"Adres Etiketi"nden Ev, İş veya Diğer\'i seçin. İl, İlçe, Mahalle, Cadde, Sokak, Apartman / Bina Adı, Site Adı, Blok, Bina No, Kat ve Daire No alanlarını doldurun ya da "Açık Adres"e serbest metin yazın.'),
      tips: [
        t(`${G}.s3.tip1`, 'Açık adres veya detaylı adres alanlarından en az biri doldurulmalıdır.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Müşteriyi kaydedin'),
      text: t(`${G}.s4.text`, '"Müşteriyi Kaydet"e basın. "Müşteri başarıyla kaydedildi!" yazısı çıkar ve pencere kendiliğinden kapanır.'),
      tips: [
        t(`${G}.s4.tip1`, 'Kayıt yapılamazsa sebebi kırmızı kutuda yazar; müşteri zaten kayıtlıysa mevcut kaydın ID numarası da gösterilir.'),
        t(`${G}.s4.tip2`, 'Başlıktaki (i) bu rehberi yeniden açar.'),
      ],
    },
  ],
});
